/** Client-side sale logger — fire-and-forget POST to the sales ledger. */
import type { PurchaseReceipt } from "@/lib/treasury";

export type SaleQuoteMeta = { slippagePct?: number; quotedSolUsd?: number; quotedAt?: number };

export function logSale(
  receipt: PurchaseReceipt,
  wallet: string | null,
  lang?: string | null,
  quote?: SaleQuoteMeta,
): void {
  if (typeof window === "undefined") return;
  const num = (s: string) => Number(String(s).replace(/,/g, "")) || 0;
  void fetch("/api/public/sale", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: receipt.token,
      payAmount: num(receipt.payAmount),
      payCurrency: receipt.payCurrency,
      receiveAmount: num(receipt.receiveAmount),
      wallet: wallet ?? null,
      signature: receipt.signature,
      cluster: receipt.cluster,
      destination: receipt.destination,
      lang: lang ?? null,
      ...(quote?.slippagePct ? { slippagePct: quote.slippagePct } : {}),
      ...(quote?.quotedSolUsd ? { quotedSolUsd: quote.quotedSolUsd } : {}),
      ...(quote?.quotedAt ? { quotedAt: quote.quotedAt } : {}),
    }),
  }).catch(() => undefined);
}
